import { Component, OnInit, OnDestroy } from '@angular/core';

import { ClosableModalWithErrorResponseModel } from '../base/closable-modal-with-error-response-model';
import { NotificationService } from '../../services';
import { ModalService } from '../../modules/modal';
import { DropdownsModalPayload, DropdownsModalDropdownData, DropdownsModalDropdownElement } from '../../models';

@Component({
  selector: 'dropdowns-modal',
  templateUrl: './dropdowns-modal.component.html',
  styleUrls: ['./dropdowns-modal.component.scss']
})
export class DropdownsModalComponent
  extends ClosableModalWithErrorResponseModel<void>
  implements OnInit, OnDestroy {

  data: DropdownsModalPayload;
  isSelectedArray: boolean[];
  showError: boolean;
  isConfirmationTextTouched: boolean;
  isConfirmationTextValid: boolean;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.showError = false;
    this.isConfirmationTextTouched = false;
    this.isConfirmationTextValid = false;
    this.subscriptions.push(this.data.saved.subscribe((isSaved: boolean) => {
      this.isSaveDisabled = false;
      if (isSaved) {
        this.closeModal();
      }
    }));
    this.isSelectedArray = new Array<boolean>(this.data.dropdowns.length).fill(false);
  }

  typeInConfirmationText(confirmationText: string): void {
    this.isConfirmationTextTouched = true;
    this.isConfirmationTextValid = confirmationText === this.data.targetConfirmationText;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onSelected(event: DropdownsModalDropdownElement, index: number): void {
    this.isSelectedArray[index] = true;
    this.initLowerDropdowns(index);
    this.data.dropdowns[index].onSelected(event);
  }

  initLowerDropdowns(index: number): void {
    for (let i = index + 1; i < this.data.dropdowns.length; i++) {
      if (!this.data.dropdowns[i].preventDropdownReset) {
        this.data.dropdowns[i].elements = [];
        this.isSelectedArray[i] = false;
      }
    }

    if (this.isSelectedArray.every(isSelected => isSelected)) {
      this.showError = false;
    }
  }

  save(): void {
    const isConfirmationTextValid = this.data.confirmationText ? this.isConfirmationTextValid : true;
    if (!isConfirmationTextValid || !this.isSelectedArray.every(isSelected => isSelected)) {
      this.isConfirmationTextTouched = true;
      this.showError = true;
    } else {
      this.isSaveDisabled = true;
      this.data.saveClicked();
    }
  }

  hasElements(dropdown: DropdownsModalDropdownData): boolean {
    return dropdown.elements && dropdown.elements.length > 0;
  }

  private closeModal(): void {
    this.success();
    this.closeAllModals();
  }

}
